// Conservative allowlist sanitiser (no external dep). Used on save, on paste and on render.
const ALLOWED = new Set(["h1", "h2", "h3", "h4", "p", "br", "strong", "b", "em", "i", "u",
  "ul", "ol", "li", "a", "table", "thead", "tbody", "tr", "td", "th", "blockquote", "span", "div", "img"]);
const ALLOWED_ATTR = { a: ["href", "target", "rel"], img: ["src", "alt"], td: ["colspan", "rowspan"], th: ["colspan", "rowspan"] };

export function sanitizeHtml(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(String(html), "text/html");
  const clean = (node) => {
    Array.from(node.children).forEach((el) => {
      const tag = el.tagName.toLowerCase();
      if (tag === "script" || tag === "style") { el.remove(); return; }
      clean(el);
      if (!ALLOWED.has(tag)) {
        const parent = el.parentNode;
        while (el.firstChild) parent.insertBefore(el.firstChild, el);
        parent.removeChild(el);
        return;
      }
      const allow = ALLOWED_ATTR[tag] || [];
      Array.from(el.attributes).forEach((a) => {
        const n = a.name.toLowerCase();
        if (!allow.includes(n)) { el.removeAttribute(a.name); return; }
        if ((n === "href" || n === "src") && /^\s*(javascript|data):/i.test(a.value)) el.removeAttribute(a.name);
      });
      if (tag === "a") { el.setAttribute("target", "_blank"); el.setAttribute("rel", "noopener noreferrer"); }
    });
  };
  clean(doc.body);
  return doc.body.innerHTML;
}

const esc = (s) => String(s == null ? "" : s).replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

// Accepts new {html} bodies OR legacy [{type,text,items}] block arrays.
export function bodyToHtml(body) {
  if (!body) return "";
  if (typeof body === "object" && !Array.isArray(body) && body.html != null) return body.html;
  if (Array.isArray(body)) {
    return body.map((x) => x.type === "heading" ? `<h2>${esc(x.text)}</h2>`
      : x.type === "list" ? `<ul>${(x.items || []).map((i) => `<li>${esc(i)}</li>`).join("")}</ul>`
        : `<p>${esc(x.text || "")}</p>`).join("");
  }
  return "";
}
